import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import AddQuickLayout from './components/add-quick-layout';
import searchMixin from '@/mixin/search';
// import { parseTime } from '@/filters/index'
import { fetchLayoutList, deleteLayoutItem } from '@/api/quick_layout';

export default {
  components: {
    AddQuickLayout: AddQuickLayout
  },
  data: function data() {
    return {
      listLoading: false,
      tableData: [],
      dialogFormVisible: false,
      quickLayoutForm: {},
      dialogEditType: ''
    };
  },

  mixins: [searchMixin],
  mounted: function mounted() {
    this.getLayoutList();
  },

  methods: {
    getLayoutList: function getLayoutList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.listLoading = true;
                _context.prev = 1;
                _context.next = 4;
                return fetchLayoutList();

              case 4:
                res = _context.sent;

                _this.tableData = _.get(res, 'data.data');
                _this.listLoading = false;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                _this.listLoading = false;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 9]]);
      }))();
    },
    handleUpdate: function handleUpdate(item) {
      this.dialogEditType = 'update';
      this.quickLayoutForm = item;
      this.showDialog(true);
    },
    handleDelete: function handleDelete(id) {
      var _this2 = this;

      this.$confirm('是否确认删除当前布局？', '提示', {
        type: 'warning'
      }).then(function () {
        _this2.handleDeleteLayoutItem(id);
      }).catch(function () {
        //
      });
    },
    handleDeleteLayoutItem: function handleDeleteLayoutItem(id) {
      var _this3 = this;

      deleteLayoutItem({
        id: id
      }).then(function (res) {
        _this3.$message({
          message: '删除成功',
          type: 'success'
        });
        _this3.getLayoutList();
      });
    },
    showDialog: function showDialog(isUpdate) {
      this.dialogEditType = isUpdate ? 'update' : 'create';
      this.dialogFormVisible = true;
    }
  }
};